module.exports = {
      id: "gzsports-usage",
      viewBox: "0 0 17.95 23.898",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#gzsports",
      toString: function () {
        return this.url;
      }
    }